/* eslint-disable */
function lightOrDark(color) {
  let r;
  let b;
  let g;
  let hsp;
  let a = color;

  if (a.match(/^rgb/)) { // rgb() colour
    a = a.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
    r = a[1];
    g = a[2];
    b = a[3];
  } else { // Hex to rgb
    a = +('0x' + a.slice(1).replace( // thanks to jed : http://gist.github.com/983661
      a.length < 5 && /./g, '$&$&'
    )
    );
    r = a >> 16;
    b = a >> 8 & 255;
    g = a & 255;
  }
  // Convert all colours in to human perception color space (Alternative to HSV)
  hsp = Math.sqrt( // HSP equation from http://alienryderflex.com/hsp.html
    0.299 * (r * r) +
    0.587 * (g * g) +
    0.114 * (b * b)
  );
  if (hsp > 127.5) {
    return 'light';
  } else {
    return 'dark';
  }
};

const brandStyler = (colours) => {
  if (!colours.hasBrandColours) {
    return;
  }
  const rgb = colours.rgb;
  let primary = colours.primary;
  let secondary = colours.secondary;
  const tertiary = colours.tertiary;
  const isLightColour = rgb[1] + rgb[2] > 450;
  if (secondary === tertiary) {
    secondary = primary;
  }
  if (primary.toUpperCase() === '#FFFFFF') {
    primary = secondary;
  }
  let primaryTextColour = secondary === '#FFF' ? secondary : tertiary;

  const head = document.getElementsByTagName('head');
  const styleElem = document.createElement('style');
  styleElem.type = 'text/css';

  if (lightOrDark(primary) === 'light' && lightOrDark(primaryTextColour)) {
    primaryTextColour = secondary;
  }
  if (primaryTextColour === primary) {
    primaryTextColour = tertiary;
  }

  const styles = `
    /***************/
    /*** BUTTONS ***/
    /***************/
    .button {
      color: ${secondary === '#FFF' ? tertiary : secondary} !important;
      border: 1px solid ${primary === '#FFF' ? tertiary : secondary} !important;
    }
      .button:hover {
        background-color: ${secondary} !important;
        color: ${tertiary} !important;
        border-color: ${secondary} !important;
      }
    .button--cta {
      background-color: ${primary} !important;
      color: ${primaryTextColour} !important;
      border-color: ${primary} !important;
    }
      .button--cta:hover {
        background-color: ${secondary} !important;
        color: #FFF !important;
        border-color: ${secondary} !important;
      }
    .button--disabled {
      background-color: #ecf0f1!important;
      color: #95a5a6 !important;
      cursor: not-allowed !important;
      pointer-events: none !important;
      border: none;
      border-color: #95a5a6 !important;
    }
    /**************/
    /*** HEADER ***/
    /**************/
    .header__left {
      background-color: ${colours.primary === '#ffffff' ? '#FFF' : primary} !important;
    }
    .header.header--mobile {
      background-color: ${colours.primary} !important;
    }
    .header.header__action-item:hover {
      background-color: ${secondary} !important;
    }
    /****************/
    /*** SIDE BAR ***/
    /****************/
    .side-bar__row {
      border-color: ${tertiary} !important;
    }
    .side-bar__documents__doc--active > div {
      border-color: ${primary} !important;
    }
    .side-bar__button {
      color: ${isLightColour ? secondary : primary} !important;
    }
    .side-bar__button:hover {
      background-color: ${primary} !important;
      color: ${secondary === '#FFF' ? secondary : tertiary} !important;
    }
    .side-bar__footer {
      background-color: ${primary} !important;
    }
    /***************/
    /*** MODALS ***/
    /***************/
    .modal__header {
      color: ${secondary} !important;
    }
    /****************/
    /*** DOCUMENT ***/
    /****************/
    .document__header {
      background-color: ${secondary} !important;
      color: ${tertiary} !important;
    }
    /********************/
    /*** DOCUMENT NAV ***/
    /********************/
    .document-navigation__button {
      background-color: ${primary} !important;
      color: ${secondary === '#FFF' ? secondary : tertiary} !important;
    }
    /*******************/
    /*** FIELD POPUP ***/
    /*******************/
    .field-popup__date-text {
      background-color: ${secondary} !important;
      color: ${tertiary} !important;
    }
    /************/
    /*** TABS ***/
    /************/
    .tabs__tab--active {
      border-color: ${primary} !important;
    }
    /****************/
    /*** CALENDAR ***/
    /****************/
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day.selected,
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month.selected,
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year.selected {
      background-color: ${primary} !important;
    }
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
      border-color: ${secondary} !important;
    }
    /**************/
    /*** FOOTER ***/
    /**************/
    .footer__info {
      color: ${secondary} !important;
    }
    /********************/
    /*** PROGRESS BAR ***/
    /********************/
    .progress__bar__amount {
      background-color: ${primary} !important;
    }
    /**********************/
    /*** ENVELOPE GUIDE ***/
    /**********************/
    .envelope-guide__slider__next,
    .envelope-guide__slider__prev {
      color: ${lightOrDark(primary) === 'light' ? secondary : secondary} !important;
    }
      .envelope-guide__slider__buttons a:hover {
        background-color: ${primary} !important;
        color: ${primaryTextColour} !important;
      }
    #Header #Logo #Rectangle {
      fill: ${primary};
    }
    #Contract #Rectangle-2 {
      stroke: ${primary};
    }
    #Document #Rectangle-5 {
      fill: ${secondary};
      color: ${tertiary} !important;
    }
    #Contracts #Button #chevron18 {
      fill: ${isLightColour ? secondary : primary} !important;
    }
    #Progress #Rectangle-7 {
      fill: ${primary};
    }
    #Footer #Rectangle {
      fill: ${primary};
    }
    #Oval-2 {
      stroke: ${tertiary};
    }
    #Outlined-button #Rectangle-3 {
      stroke: ${secondary};
    }
    #Outlined-button text {
      fill: ${secondary};
    }
    #Cta-button #Rectangle-3 {
      fill: ${primary};
    }
    #Cta-button text {
      fill: ${primaryTextColour} !important;
    }
    #Items-to-complete text {
      fill: ${secondary};
    }
    #Outlined-button [filter="url(#blurMe)"],
    #Cta-button [filter="url(#blurMe)"]{
      stroke: rgb(248, 231, 28)!important;
      fill: none !important;
    }
    /
  `;
  if (styleElem.styleSheet) {
    styleElem.styleSheet.cssText = styles;
  } else {
    const styleText = document.createTextNode(styles);
    styleElem.appendChild(styleText);
  }
  head[0].appendChild(styleElem);
};

export default brandStyler;
